import { Button, Stack, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import "./styles.scss";
import { ErrorMessage } from "../error-message";

export const StepFormContainer = ({
  step,
  visible,
  isValid,
  children,
  onSubmit,
  onBack,
  buttonText = "Continue",
  saveAndExit,
  error,
}: PropsWithChildren<{
  step: number;
  visible: boolean;
  isValid: boolean;
  onBack: () => void;
  onSubmit: () => void;
  buttonText?: string;
  saveAndExit?: () => void;
  error?: string | null;
}>) => {
  if (!visible) return null;

  return (
    <div className="step-form-container" data-step={step}>
      <ErrorMessage message={error} />
      {children}

      <div className="site-wrapper">
        <div className="step-form-footer">
          {/* Top row: Back and Continue buttons */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="footer-top-row"
          >
            <Button color={"black" as any} onClick={onBack}>
              <Stack direction="row" spacing={1}>
                <ChevronLeft />
                <Typography variant="body1" component="span" fontWeight={400}>
                  {step > 0 ? "Back" : "Cancel"}
                </Typography>
              </Stack>
            </Button>
            <Button
              color={"black" as any}
              variant="contained"
              onClick={onSubmit}
              disabled={!isValid}
            >
              <Typography variant="body1" component="span" fontWeight={400} color="white">
                {buttonText}
              </Typography>
            </Button>
          </Stack>
          
          {/* Bottom row: Save & Exit button (centered) */}
          {saveAndExit && (
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              className="footer-bottom-row"
            >
              <Button
                variant="outlined"
                color={"black" as any}
                onClick={saveAndExit}
                className="save-exit-button"
              >
                <Typography variant="body1" component="span" fontWeight={400}>
                  Save and Exit
                </Typography>
              </Button>
            </Stack>
          )}
        </div>
      </div>
    </div>
  );
};
